import { v7 as uuidv7 } from "uuid";

export const generateCorrelationId = (): string => uuidv7();

export const formatErrorTimestamp = (date: Date): string =>
  date.toLocaleString("pl-PL", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
